// @flow

import getPinTypes from 'app/common/react/components/PinRep/utils/getPinTypes';
import i18n from 'app/common/lib/i18n';
import { type Pin } from 'app/common/react/components/PinRep/types';

export default function getAttributionProps(pin: Pin) {
  const { board, pinner = {}, promoter } = pin;
  const { isPromoted } = getPinTypes(pin);

  let avatarUrl = '';
  let attributionNameLink = '';
  let attributionTitle = '';
  let name = '';
  let url = '';

  if (isPromoted && promoter) {
    avatarUrl = promoter.image_medium_url || promoter.image_small_url;
    attributionTitle = promoter.full_name;
    name = i18n._('Promoted by', 'indicating the username of the person who promoted the pin');
    url = `/${promoter.username}/`;
  } else {
    avatarUrl = pinner.image_medium_url || pinner.image_small_url;
    attributionNameLink = `/${pinner.username}/`;
    name = pinner.full_name;
    url = board ? board.url : '';
  }

  return {
    avatarUrl,
    attributionNameLink,
    attributionTitle,
    name,
    url,
  };
}
